import { AuthService } from 'app/_services/auth.service';
import { ErrorHandler } from 'app/_services/error-handler.factory';
import { StorageLocationResource } from 'app/_resources/storage-location.resource';
import { StorageFcfsOfferResource } from 'app/_resources/storage-fcfs-offer.resource';
import { StorageFcfsRequestResource } from 'app/_resources/storage-fcfs-request.resource';
import * as angular from 'angular';
import { mgoAngularWizard, StorageBookingWizardContext } from '../custom';
import { config, reactShell } from 'angular/utils/config';
import * as moment from 'pkp-moment-timezone-all-years';

class StorageBookingWizardProductCtrl implements ng.IController {
    private static readonly MAX_FILENAME_SIZE = 52;
    private wizardCtrl: mgoAngularWizard.Wizard<StorageBookingWizardContext>;
    public loading: boolean = true;
    public isLoggedIn: boolean;
    public storageFcfsOfferList: StorageFcfsOfferDto[];
    public storageFcfsRequest = <StorageFcfsRequestDto>{};
    public offerRuntime: DateInterval = <DateInterval>{};
    public form: ng.IFormController;
    public stageConfig = config;
    public reactShell = reactShell;

    constructor(
        private authService: AuthService,
        private errorHandler: ErrorHandler,
        private storageLocationResource: StorageLocationResource,
        private storageFcfsOfferResource: StorageFcfsOfferResource,
        private storageFcfsRequestResource: StorageFcfsRequestResource
    ) {
        this.isLoggedIn = this.authService.getLoggedInUser() != null;
    }

    $onInit() {
        if (this.wizardCtrl.context.storageFcfsRequest != null) {
            this.storageFcfsRequest =
                this.wizardCtrl.context.storageFcfsRequest;
            this.offerRuntime = <DateInterval>{};
            this.offerRuntime.start =
                this.wizardCtrl.context.selectedFcfsOffer.runtimeStart;
            this.offerRuntime.end =
                this.wizardCtrl.context.selectedFcfsOffer.runtimeEnd;
        }
        this.storageLocationResource
            .getFcfsOffersForLocation(
                { id: this.wizardCtrl.context.selectedLocation.refId },
                (res: StorageFcfsOfferDto[]) => {
                    this.storageFcfsOfferList = res;
                },
                this.errorHandler
            )
            .$promise.finally(() => (this.loading = false));
    }

    public onSelected(): void {
        // Offer select from drop down list. Putting values into request ...
        if (angular.isUndefined(this.wizardCtrl.context.selectedFcfsOffer)) {
            return;
        }

        this.wizardCtrl.context.selectedFcfsOfferAttachmentList = null;
        let tmpQuantity: StorageQuantityDto = {
            value: 1,
            unit: this.wizardCtrl.context.selectedFcfsOffer.unit
        };
        this.storageFcfsRequest.offerId =
            this.wizardCtrl.context.selectedFcfsOffer.id;
        this.storageFcfsRequest.quantity = tmpQuantity;

        const now = moment();
        const TIME_ZONE = 'Europe/Berlin';
        const todayAtSix = moment(now)
            .tz(TIME_ZONE)
            .hour(6)
            .minute(0)
            .second(0)
            .millisecond(0);

        if (now.isBefore(todayAtSix)) {
            this.wizardCtrl.context.selectedFcfsOffer.runtimeStart = todayAtSix
                .clone()
                .subtract(1, 'day')
                .toDate();
        } else {
            this.wizardCtrl.context.selectedFcfsOffer.runtimeStart =
                todayAtSix.toDate();
        }

        let runtimeEnd = moment(
            this.wizardCtrl.context.selectedFcfsOffer.runtimeEnd
        ).tz(TIME_ZONE);
        if (runtimeEnd.isBefore(now)) {
            const tomorrowAtSix = moment()
                .tz(TIME_ZONE)
                .add(1, 'day')
                .hour(6)
                .minute(0)
                .second(0)
                .millisecond(0);
            this.wizardCtrl.context.selectedFcfsOffer.runtimeEnd =
                tomorrowAtSix.toDate();
        }

        this.storageFcfsRequest.runtimeStart =
            this.wizardCtrl.context.selectedFcfsOffer.runtimeStart;
        this.storageFcfsRequest.runtimeEnd =
            this.wizardCtrl.context.selectedFcfsOffer.runtimeEnd;
        this.storageFcfsRequest.userEmail =
            this.authService.getLoggedInUser().email;
        this.wizardCtrl.context.storageFcfsRequest = this.storageFcfsRequest;
        this.offerRuntime = <DateInterval>{};
        this.offerRuntime.start =
            this.wizardCtrl.context.selectedFcfsOffer.runtimeStart;
        this.offerRuntime.end =
            this.wizardCtrl.context.selectedFcfsOffer.runtimeEnd;
        this.wizardCtrl.context.storageFcfsRequestRuntime = <DateInterval>{};
        this.wizardCtrl.context.storageFcfsRequestRuntime.start =
            this.offerRuntime.start;
        this.wizardCtrl.context.storageFcfsRequestRuntime.end =
            this.offerRuntime.end;

        console.log(
            'OfferRuntime: ' +
                this.offerRuntime.start +
                ' - ' +
                this.offerRuntime.end
        );

        // search for attached documents for this offer ...

        this.wizardCtrl.context.selectedFcfsOfferAttachmentList = [];
        this.storageFcfsOfferResource.getAttachments(
            { id: this.wizardCtrl.context.selectedFcfsOffer.id },
            (res: DocumentDto[]) => {
                this.wizardCtrl.context.selectedFcfsOfferAttachmentList = res;
                angular.forEach(
                    this.wizardCtrl.context.selectedFcfsOfferAttachmentList,
                    (doc) => {
                        if (
                            doc.name.length >
                            StorageBookingWizardProductCtrl.MAX_FILENAME_SIZE
                        ) {
                            let tmpName =
                                doc.name.substring(
                                    0,
                                    StorageBookingWizardProductCtrl.MAX_FILENAME_SIZE -
                                        3
                                ) +
                                '...' +
                                doc.name.substring(doc.name.length - 3);
                            doc.name = tmpName;
                        }
                    }
                );
            },
            this.errorHandler
        );
    }

    public checkAvailability(): void {
        this.storageFcfsRequest.runtimeStart =
            this.wizardCtrl.context.storageFcfsRequestRuntime.start;
        this.storageFcfsRequest.runtimeEnd =
            this.wizardCtrl.context.storageFcfsRequestRuntime.end;
        this.storageFcfsRequestResource.checkAvailability(
            this.storageFcfsRequest,
            (res: StorageFcfsRequestDto) => {
                let tmpReq: StorageFcfsRequestDto = res;
                if (tmpReq.id > 0) {
                    this.wizardCtrl.context.storageFcfsRequest = tmpReq;
                    this.wizardCtrl.next();
                } else {
                }
            },
            (err) => {
                this.errorHandler(err);
            }
        );
    }

    public submit(form: ng.IFormController): boolean {
        if (!form.$valid) {
            return false;
        }
        this.checkAvailability();
        return true;
    }
}

angular.module('app').component('pkpStorageBookingWizardProduct', {
    controller: StorageBookingWizardProductCtrl,
    template:
        require('app/storage-booking-wizard/storage-booking-wizard-product.component.html'),
    require: {
        wizardCtrl: '^^wizard'
    },
    bindings: {}
});
